import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import Button from '../Button';

interface BulkActionBarProps {
  selectedCount: number;
  canSuspend: boolean;
  onSuspend: () => void;
  onClear: () => void;
}

/** US-052 AC2: appears once >=1 tenant is selected; Notify/Change Plan are visible but disabled — their backend (US-046/US-042) doesn't exist yet. */
const BulkActionBar: React.FC<BulkActionBarProps> = ({ selectedCount, canSuspend, onSuspend, onClear }) => {
  const { t } = useTranslation();

  if (selectedCount === 0) return null;

  return (
    <div className="d-flex align-items-center gap-3 p-3 mb-3 rounded" style={{ backgroundColor: 'rgba(var(--bs-primary-rgb), 0.06)' }}>
      <span className="fw-medium">
        {t('tenants.list.pageTexts.bulk.selectedCount', { count: selectedCount })}
      </span>
      <div className="d-flex gap-2">
        {canSuspend && (
          <Button className="btn btn-sm btn-danger" text={t('tenants.list.pageTexts.bulk.suspend')} onClick={onSuspend} />
        )}
        <Tooltip title={t('tenants.list.pageTexts.bulk.comingSoon')}>
          <span>
            <Button className="btn btn-sm btn-outline-secondary" text={t('tenants.list.pageTexts.bulk.notify')} disabled onClick={() => {}} />
          </span>
        </Tooltip>
        <Tooltip title={t('tenants.list.pageTexts.bulk.comingSoon')}>
          <span>
            <Button className="btn btn-sm btn-outline-secondary" text={t('tenants.list.pageTexts.bulk.changePlan')} disabled onClick={() => {}} />
          </span>
        </Tooltip>
      </div>
      <Button className="btn btn-sm btn-link ms-auto" text={t('tenants.list.pageTexts.bulk.clearSelection')} onClick={onClear} />
    </div>
  );
};

export default BulkActionBar;
